import React, { useState } from 'react'

export default function Fields({selected, fieldIndex, fields, onChangeField, multiSelect}) {
  const [small, setSmall] = useState(true)

  const selectedGroup = small ? fields.simple : fields.compound

  const showField = (field, index) => {  
    return <label style={field.styles} key={index}>
      <div className='field-title-name'>{field.name}</div>
      { !multiSelect &&
        <input
          type='radio'
          value={field.id}
          checked={`${field.id}` === `${selected}`}
          onChange={(e) => onChangeField(e.target.value)}
        />
      }
      { multiSelect &&
        <input
          type='checkbox'
          value={field.id}
          checked={`${selected}`.split(',').includes(`${field.id}`)}
          onChange={(e) => onChangeField(e.target.value)}
        />
      }
      <div style={{backgroundImage: `url(${field.image_url})`}} className='wrap_field'></div>
    </label>
  }

  return <div className='col-sm-12'>
    <div className='location_fields'>
      { fields.compound.length > 0 &&
        <div className='field-type-selector'>
          <label>
            <input 
              name={`field-selector[${fieldIndex}]`}
              type='radio' 
              value='small'
              checked={small}
              onChange={(e) => setSmall(e.target.value == 'small')}
            />
            <span>Small</span>
          </label>
          <label>
            <input 
              name={`field-selector[${fieldIndex}]`} 
              type='radio' 
              value='large'
              checked={!small}
              onChange={(e) => setSmall(e.target.value == 'small')}
            />
            <span>Large</span>
          </label>
        </div>
      }
      <div className='field_layout' style={{height: `${fields.height}px`}}>
        {
          selectedGroup.map((f, i) => showField(f, i))
        }
      </div>
    </div>
  </div>
}
